var map = {
	"./audio_placeholder": 416,
	"./audio_placeholder.mp3": 416,
	"./audio_placeholder2": 417,
	"./audio_placeholder2.mp3": 417,
	"./audio_placeholder3": 418,
	"./audio_placeholder3.mp3": 418,
	"./kid/lesson_1/audio_tpc1": 419,
	"./kid/lesson_1/audio_tpc1.m4a": 419,
	"./kid/lesson_10/audio_tpc10": 420,
	"./kid/lesson_10/audio_tpc10.m4a": 420,
	"./kid/lesson_10/audio_tpc10_recompensa": 421,
	"./kid/lesson_10/audio_tpc10_recompensa.m4a": 421,
	"./kid/lesson_11/audio_tpc11": 422,
	"./kid/lesson_11/audio_tpc11.m4a": 422,
	"./kid/lesson_11/audio_tpc11_recompensa": 423,
	"./kid/lesson_11/audio_tpc11_recompensa.m4a": 423,
	"./kid/lesson_2/audio_tpc2": 424,
	"./kid/lesson_2/audio_tpc2.m4a": 424,
	"./kid/lesson_3/audio13": 425,
	"./kid/lesson_3/audio13.m4a": 425,
	"./kid/lesson_3/audio15": 426,
	"./kid/lesson_3/audio15.m4a": 426,
	"./kid/lesson_3/audio4": 427,
	"./kid/lesson_3/audio4.m4a": 427,
	"./kid/lesson_3/audio5": 428,
	"./kid/lesson_3/audio5.m4a": 428,
	"./kid/lesson_3/audio6": 429,
	"./kid/lesson_3/audio6.m4a": 429,
	"./kid/lesson_4/audio_tpc4": 430,
	"./kid/lesson_4/audio_tpc4.m4a": 430,
	"./kid/lesson_5/audio20": 431,
	"./kid/lesson_5/audio20.m4a": 431,
	"./kid/lesson_5/audio21": 432,
	"./kid/lesson_5/audio21.m4a": 432,
	"./kid/lesson_5/audio22": 433,
	"./kid/lesson_5/audio22.m4a": 433,
	"./kid/lesson_5/audio_AnaAdivinhadora": 434,
	"./kid/lesson_5/audio_AnaAdivinhadora.m4a": 434,
	"./kid/lesson_5/audio_EdgarExagerado": 435,
	"./kid/lesson_5/audio_EdgarExagerado.m4a": 435,
	"./kid/lesson_5/audio_NiniNegativa": 436,
	"./kid/lesson_5/audio_NiniNegativa.m4a": 436,
	"./kid/lesson_5/audio_SebastiaoSaltitao": 437,
	"./kid/lesson_5/audio_SebastiaoSaltitao.m4a": 437,
	"./kid/lesson_6/audio_tpc6": 438,
	"./kid/lesson_6/audio_tpc6.m4a": 438,
	"./kid/lesson_7/audio32": 439,
	"./kid/lesson_7/audio32.m4a": 439,
	"./kid/lesson_7/audio33": 440,
	"./kid/lesson_7/audio33.m4a": 440,
	"./kid/lesson_7/audio34": 441,
	"./kid/lesson_7/audio34.m4a": 441,
	"./kid/lesson_7/audio36": 442,
	"./kid/lesson_7/audio36.m4a": 442,
	"./kid/lesson_7/audio37": 443,
	"./kid/lesson_7/audio37.m4a": 443,
	"./kid/lesson_7/audio38": 444,
	"./kid/lesson_7/audio38.m4a": 444,
	"./kid/lesson_7/audio39": 445,
	"./kid/lesson_7/audio39.m4a": 445,
	"./kid/lesson_7/audio40": 446,
	"./kid/lesson_7/audio40.m4a": 446,
	"./kid/lesson_7/audio41": 447,
	"./kid/lesson_7/audio41.m4a": 447,
	"./kid/lesson_7/audio42": 448,
	"./kid/lesson_7/audio42.m4a": 448,
	"./kid/lesson_7/audio43": 449,
	"./kid/lesson_7/audio43.m4a": 449,
	"./kid/lesson_7/audio44": 450,
	"./kid/lesson_7/audio44.m4a": 450,
	"./kid/lesson_7/audio46": 451,
	"./kid/lesson_7/audio46.m4a": 451,
	"./kid/lesson_8/audio_tpc8": 452,
	"./kid/lesson_8/audio_tpc8.m4a": 452,
	"./kid/lesson_8/audio_tpc8_guloseima": 453,
	"./kid/lesson_8/audio_tpc8_guloseima.m4a": 453,
	"./kid/lesson_8/audio_tpc8_pedrinha": 454,
	"./kid/lesson_8/audio_tpc8_pedrinha.m4a": 454,
	"./kid/lesson_8/audio_tpc8_plasticina": 455,
	"./kid/lesson_8/audio_tpc8_plasticina.m4a": 455,
	"./kid/lesson_8/audio_tpc8_volta": 456,
	"./kid/lesson_8/audio_tpc8_volta.m4a": 456,
	"./kid/lesson_9/audio52": 457,
	"./kid/lesson_9/audio52.m4a": 457,
	"./kid/lesson_9/audio53": 458,
	"./kid/lesson_9/audio53.m4a": 458,
	"./kid/lesson_9/audio56": 459,
	"./kid/lesson_9/audio56.m4a": 459,
	"./kid/lesson_9/audio57": 460,
	"./kid/lesson_9/audio57.m4a": 460,
	"./kid/lesson_9/audio58": 461,
	"./kid/lesson_9/audio58.m4a": 461,
	"./kid/lesson_9/audio59": 462,
	"./kid/lesson_9/audio59.m4a": 462,
	"./kid/lesson_9/audio60": 463,
	"./kid/lesson_9/audio60.m4a": 463,
	"./kid/lesson_9/audio70": 464,
	"./kid/lesson_9/audio70.m4a": 464,
	"./kid/lesson_9/audio71": 465,
	"./kid/lesson_9/audio71.m4a": 465,
	"./kid/lesson_9/audio72": 466,
	"./kid/lesson_9/audio72.m4a": 466,
	"./kid/lesson_9/audio73": 467,
	"./kid/lesson_9/audio73.m4a": 467,
	"./parent/lesson_3/audio5": 468,
	"./parent/lesson_3/audio5.m4a": 468,
	"./parent/lesson_3/audio6": 469,
	"./parent/lesson_3/audio6.m4a": 469,
	"./parent/lesson_8/audio4": 470,
	"./parent/lesson_8/audio4.m4a": 470
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 505;